<template>

  <div id="HearingCalibrations">
    <HearingSteps current-step="Calibration" :dot-count="calibrations.length" :currentDot="currCount"></HearingSteps>
    <div id="calibration" v-if="calibrationType == ''" >
      <div class="info-help">
        <div class="HearingTest-test--title ng-binding">کالیبراسیون صوتی</div>
        <div class="HearingTest-test--text ng-binding">قبل از اینکه تست را آغاز کنید ما باید تعیین کنیم که شما از هدفون استفاده میکنید یا بلندگو. بهتر است که از هدفون استفاده نمایید چراکه آزمون ها برای هرگوش بطور مجزا گرفته میشود، اگر از هدفون استفاده نشود نتیجه مشخصی برای هر گوش بدست نمی آید.</div>
        <div class="HearingTest-test--textBold ng-binding">مهم است که قبل از شروع تست، صدای کامپیوترتان را روی 50 درصد تنظیم کنید. لطفا یک گزینه را انتخاب کنید.</div>
      </div>
      <v-layout row wrap justify-center align-center >
        <v-flex id="first-btn" sm4 xs8 style="margin-left: 50px">
          <v-btn block class="question-btn" @click="calibrationType = 'headphone'" >{{ headphone }}</v-btn>
        </v-flex>
        <v-flex sm4 xs8>
          <v-btn block class="question-btn" @click="calibrationType = 'speaker'" >{{ speaker }}</v-btn>
        </v-flex>
      </v-layout>
      <div class="clearfix"></div>
    </div>
    <Headphone  v-if="calibrationType == 'headphone'"></Headphone>
    <speaker v-if="calibrationType == 'speaker'"></speaker>
  </div>

</template>

<script>
  import HearingSteps from './steps.vue';
  import Headphone from './HearingCalibrationHeadphone.vue';
  import speaker from './HearingCalibrationSpeaker.vue';
export default {
    name: 'HearingCalibration',

    components: {
        HearingSteps,
        Headphone,
        speaker
    },
  mounted() {
      // check user passed prev steps, if not go home!
      if(!window.questionsAnswer)
          this.$parent.$router.replace('/');

  },
  data () {

    return {
        loaded: false,
        speaker: 'بلندگو',
        headphone: 'هدفون',
        calibrationType :'',
        calibrations:{},
        currCount:1,
        answers : [],
    }
  },
    watch: {
        calibrationType: function (val) {
            window.calibrationType = val;
        },
    }
}
</script>

<style scoped>
  #calibration{
    margin: 40px 0;
    text-align: center;
    padding: 0 10px 30px;
  }

  #calibration .question-btn{
    text-align: center;
    cursor: pointer;
    border: none;
    margin: 0 auto 20px;
    padding-top: 12px;
    padding-bottom: 10px;
    display: inline-block;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 599px){

    #first-btn{
      margin: 0 !important;
    }
  }
  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--textBold {
    text-align: center;
    margin: 0 4% 30px;
    font-weight: normal;
    font-style: normal;
    font-size: 19px;
    line-height: 22px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingCalibration.vue